import TextArea from 'components/TextArea/TextArea'
import TextInput from 'components/TextInput/TextInput'
import AlbumArt from 'components/AlbumArt/AlbumArt'
import 'react-calendar/dist/Calendar.css'
import DateInput from 'components/DateInput/DateInput'

const MetadataTab = ({
  values,
  onChange,
  onSubmit,
  isBulkEdit,
  mixedValues,
  onMixedValuesChange,
}) => {
  function handleFieldChange(evt) {
    onChange(
      {
        ...values,
        [evt.target.name]: evt.target.value,
      },
      evt.target.name,
    )
  }

  function handleAlbumArtChange(url) {
    onChange(
      {
        ...values,
        art: url,
      },
      'art',
    )
  }

  function handleUnlock(field) {
    onMixedValuesChange({
      ...mixedValues,
      [field]: false,
    })
  }

  return (
    <div className="flex flex-row">
      <AlbumArt value={values.art} onChange={handleAlbumArtChange} />
      <div className="flex-1 px-6">
        <div className="flex flex-row flex-wrap">
          <div className="w-1/2 2xl:w-1/3 mb-6 pr-2 relative">
            <TextInput
              label="Name"
              value={values.name || ''}
              name="name"
              onChange={handleFieldChange}
              disabled={isBulkEdit}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 mb-6 pr-2 relative">
            <TextInput
              label="Artist"
              value={values.artist}
              name="artist"
              onChange={handleFieldChange}
              isLocked={mixedValues?.artist}
              onUnlock={() => handleUnlock('artist')}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 mb-6 relative">
            <TextInput
              label="Album"
              value={values.album}
              name="album"
              onChange={handleFieldChange}
              isLocked={mixedValues?.album}
              onUnlock={() => handleUnlock('album')}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 mb-6 pr-2 relative">
            <DateInput
              label="Release Date"
              value={values.releaseDate}
              name="releaseDate"
              onChange={handleFieldChange}
              isLocked={mixedValues?.releaseDate}
              onUnlock={() => handleUnlock('releaseDate')}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 mb-6 pr-2 relative">
            <TextInput
              label="Composer"
              value={values.composer}
              name="composer"
              onChange={handleFieldChange}
              isLocked={mixedValues?.composer}
              onUnlock={() => handleUnlock('composer')}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 mb-6 relative">
            <TextInput
              label="Genre"
              value={values.genre}
              name="genre"
              onChange={handleFieldChange}
              isLocked={mixedValues?.genre}
              onUnlock={() => handleUnlock('genre')}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 mb-6 pr-2 relative">
            <TextInput
              label="Grouping"
              value={values.grouping}
              name="grouping"
              onChange={handleFieldChange}
              isLocked={mixedValues?.grouping}
              onUnlock={() => handleUnlock('grouping')}
            />
          </div>
          <div className="w-1/2 2xl:w-1/3 flex flex-row">
            <div className="w-full mb-6 pr-2 relative">
              <TextInput
                label="Album Artist"
                value={values.albumArtist}
                name="albumArtist"
                onChange={handleFieldChange}
                isLocked={mixedValues?.albumArtist}
                onUnlock={() => handleUnlock('albumArtist')}
              />
            </div>
          </div>
          <div className="w-1/2 2xl:w-1/3 flex flex-row">
            <div className="w-1/2 mb-6 pr-2 relative">
              <TextInput
                label="BPM"
                value={values.bpm}
                name="bpm"
                type="number"
                onChange={handleFieldChange}
                isLocked={mixedValues?.bpm}
                onUnlock={() => handleUnlock('bpm')}
              />
            </div>

            <div className="w-1/2 mb-6 relative">
              <TextInput
                label="ISRC"
                value={values.isrc}
                name="isrc"
                onChange={handleFieldChange}
                isLocked={mixedValues?.isrc}
                onUnlock={() => handleUnlock('isrc')}
              />
            </div>
          </div>
          <div className="w-1/2 mb-6 pr-2 relative">
            <TextArea
              label="Description (public)"
              value={values.description}
              name="description"
              onChange={handleFieldChange}
              isLocked={mixedValues?.description}
              onUnlock={() => handleUnlock('description')}
            />
          </div>
          <div className="w-1/2 mb-6 relative">
            <TextArea
              label="Notes (private)"
              value={values.notes}
              name="notes"
              onChange={handleFieldChange}
              isLocked={mixedValues?.notes}
              onUnlock={() => handleUnlock('notes')}
            />
          </div>
        </div>
        <button
          className="button bg-pink hover:bg-pink-off"
          onClick={() => onSubmit(values)}
        >
          Save
        </button>
      </div>
    </div>
  )
}

export default MetadataTab
